import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./date-planning-section.css";

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const getUpcomingDates = () => {
  const today = new Date();
  return Array.from({ length: 7 }, (_, index) => {
    const date = new Date(today.getFullYear(), today.getMonth(), today.getDate() + index + 1);
    return {
      value: formatDate(date),
      weekday: date.toLocaleDateString("en-IN", { weekday: "short" }),
      day: date.toLocaleDateString("en-IN", { day: "numeric" }),
      month: date.toLocaleDateString("en-IN", { month: "short" }),
    };
  });
};

export default function DatePlanningSection() {
  const navigate = useNavigate();
  const [dates] = useState(getUpcomingDates);
  const [selectedDate, setSelectedDate] = useState(dates[0].value);

  const continuePlanning = () => {
    const params = new URLSearchParams({ event_date: selectedDate });
    navigate(`/planner?${params.toString()}`);
  };

  return (
    <section className="date-planning-section" data-testid="date-planning-section">
      <div className="date-planning-panel">
        <header className="date-planning-heading">
          <span className="date-planning-eyebrow landing-section-eyebrow">Start with a date</span>
          <h2 className="font-serif landing-section-heading">When are you <em>celebrating?</em></h2>
          <p>Choose a day to begin planning. Artist availability depends on your event details.</p>
        </header>

        <div className="date-planning-days" role="group" aria-label="Choose an event date">
          {dates.map((date) => {
            const selected = selectedDate === date.value;
            return (
              <button
                key={date.value}
                type="button"
                className={`date-planning-day ${selected ? "selected" : ""}`}
                aria-pressed={selected}
                onClick={() => setSelectedDate(date.value)}
                data-testid={`date-planning-${date.value}`}
              >
                <span className="date-planning-weekday">{date.weekday}</span>
                <strong>{date.day}</strong>
                <span className="date-planning-month">{date.month}</span>
              </button>
            );
          })}
        </div>

        <div className="date-planning-footer">
          <p>Have another date in mind? You can change it in the planner.</p>
          <button
            type="button"
            className="date-planning-cta"
            onClick={continuePlanning}
            data-testid="date-planning-continue"
          >
            Plan for {dates.find((date) => date.value === selectedDate)?.day}{" "}
            {dates.find((date) => date.value === selectedDate)?.month} →
          </button>
        </div>
      </div>
    </section>
  );
}
